








import { defineComponent } from '@vue/composition-api'
import { PropType } from 'vue';
import PageBuilderComponent from '~/mixins/solepro/PageBuilderComponent.vue';
import { ColumnType } from '~/types/solepro/PageBuilder';

export default defineComponent({
    name: "ColumnGroup",
    mixins: [PageBuilderComponent],
    components: {
        PageBuilderComponent
    },
    props: {
        node: {
            type: Object as PropType<ColumnType>,
            required: true
        }
    },
    setup(props) {
        const content = props.node as ColumnType;
        const WrapperComponent = content.tagname.toLowerCase();

        return {
            WrapperComponent,
            content,

        }
    }
})
